import {ActionReducerMapBuilder} from '@reduxjs/toolkit';

import {NotificationState} from './slicer';
import {listNotifications, registerToken} from './thunk';

export const notificationBuilder = (builder: ActionReducerMapBuilder<NotificationState>) => {
  builder
    .addCase(registerToken.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(registerToken.fulfilled, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(registerToken.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(listNotifications.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(listNotifications.fulfilled, (state: any, action: any) => {
      let temp: any = {};
      if (action.payload.data?.messages) {
        if (
          state.notifications &&
          state.notifications.messages?.length &&
          state.notifications.page !== action.payload.data.page
        ) {
          temp = {
            ...state.notifications,
            messages: [...state.notifications.messages, ...action.payload.data.messages]
          };
        } else {
          temp = action.payload.data;
        }
      } else {
        temp = action.payload.data;
      }
      state.notifications = temp;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(listNotifications.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });
};
